module.exports = __webpack_public_path__ + "static/setup-861a1e9f12ae2bda2269627cae0f5fb2.svg";